import { Component } from '@verndale/core';

class OptiForm extends Component {
  setupDefaults() {
    this.dom = {
      inputs: this.el.querySelectorAll(
        'input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="url"], input[type="textarea"], select, textarea'
      )
    };

    this.checkInputs();
  }

  addListeners() {
    (this.dom.inputs as NodeListOf<HTMLInputElement>).forEach(input => {
      input.addEventListener('focus', this.handleFocus.bind(this));
      input.addEventListener('blur', this.handleBlur.bind(this));
    });
  }

  checkInputs() {
    (this.dom.inputs as NodeListOf<HTMLInputElement>).forEach(input => {
      this.verifyInputValue(input);
    });
  }

  handleFocus(e: FocusEvent) {
    const target = e.target as HTMLInputElement;

    const parent = target.closest('.Form__Element');
    parent?.classList.add('has-focus');
  }

  handleBlur(e: FocusEvent) {
    const target = e.target as HTMLInputElement;

    this.verifyInputValue(target);
  }

  verifyInputValue(el: HTMLInputElement) {
    const parent = el.closest('.Form__Element');

    if (el.value) {
      parent?.classList.add('has-value');
    } else {
      parent?.classList.remove('has-value');
    }
    parent?.classList.remove('has-focus');
  }
}

export default OptiForm;
